/**
 * Big banner animation — Monday 3211257660
 *
 * Reference: thrivin.com/en-de. On the home page slideshows the banner copy
 * (heading, subline, CTA) leaves and comes back element after element every
 * time the slideshow moves to the next banner, over the crossfade between the
 * two images (the fade effect itself is set on the Swiper in index.layout.js).
 *
 * The copy of the banner you land on is simply there, with no effect: the
 * animation belongs to the change, not to the arrival. Single banners outside
 * a slideshow are not animated at all.
 *
 * This file only marks up what the stylesheet animates, and it only does so
 * once Swiper is running and has an active slide — so a page where that never
 * happens keeps its banners exactly as they were, with the copy visible.
 */
(function () {
  var SLIDER_SELECTOR = '.swiper-container.wb-home-banner[id^="home_banner"]';
  var CONTENT_SELECTOR = '.wb-hero-banner__content';
  var ACTIVE_SLIDE_SELECTOR = '.swiper-slide-active';
  var SLIDER_CLASS = 'wb-home-banner--anim';
  var MOVE_CLASS = 'wb-anim-move';
  var READY_POLL = 200;
  var READY_TIMEOUT = 4000;

  function isPositioned(element) {
    return getComputedStyle(element).position !== 'static';
  }

  /**
   * A transform turns an element into the containing block of its absolutely
   * positioned descendants, and several banners position their CTA that way —
   * moving those would drop the button on top of the heading. Such elements
   * are left to fade on the spot; everything else also slides.
   */
  function canMove(element) {
    if (isPositioned(element)) {
      return true;
    }
    return !Array.prototype.some.call(element.querySelectorAll('*'), isPositioned);
  }

  function markMovableCopy(slider) {
    Array.prototype.forEach.call(slider.querySelectorAll(CONTENT_SELECTOR), function (block) {
      Array.prototype.forEach.call(block.children, function (child) {
        if (canMove(child)) {
          child.classList.add(MOVE_CLASS);
        }
      });
    });
  }

  /**
   * Calls back for each slider as soon as Swiper has given it an active slide,
   * and gives up on the ones that never get one.
   */
  function waitForActiveSlide(sliders, onReady) {
    var waiting = sliders.slice();
    var attemptsLeft = Math.ceil(READY_TIMEOUT / READY_POLL);

    function check() {
      waiting = waiting.filter(function (slider) {
        if (!slider.querySelector(ACTIVE_SLIDE_SELECTOR)) {
          return true;
        }
        onReady(slider);
        return false;
      });

      attemptsLeft -= 1;
      if (waiting.length && attemptsLeft > 0) {
        window.setTimeout(check, READY_POLL);
      }
    }

    // A timeout rather than a frame: this has to happen after every other
    // DOMContentLoaded handler, and unlike frames, timers also run while the
    // page sits in a background tab.
    window.setTimeout(check, 0);
  }

  function init() {
    var sliders = Array.prototype.filter.call(
      document.querySelectorAll(SLIDER_SELECTOR),
      function (slider) {
        return !!slider.querySelector(CONTENT_SELECTOR);
      }
    );

    if (!sliders.length) {
      return;
    }

    sliders.forEach(markMovableCopy);

    // index.layout.js starts Swiper in its own DOMContentLoaded handler, which
    // runs after this one. Marking a slider before that would hide the copy of
    // every slide, so the class only goes on once there is an active slide to
    // keep visible; a slideshow that never starts is simply left alone, copy
    // and all.
    waitForActiveSlide(sliders, function (slider) {
      slider.classList.add(SLIDER_CLASS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
